/** Declined-reason codes from AAL API (`reason` field); chart uses readable labels. */
export const WITHDRAWAL_TOP_DECLINED_REASON_LABELS = {
  stuck_redemptions: "Stuck redemptions",
  ato: "ATO",
  stolen_cards: "Stolen cards",
  duplicate_redemption: "Duplicate redemption",
  recognized_patterns_with_improper_wagers: "Recognized patterns with improper wagers",
  account_selling_sharing: "Account selling / sharing",
  referral_bonus_abuse: "Referral bonus abuse",
  multiaccounting: "Multiaccounting",
  other: "Other",
};

/** Approved-reason codes from AAL top-approved-reasons (`reason` field). */
export const WITHDRAWAL_TOP_APPROVED_REASON_LABELS = {
  sportsbook: "Sportsbook",
  casino: "Casino",
  sportsbook_and_casino: "Sportsbook and casino",
  other: "Other",
};

export const WITHDRAWAL_DECLINE_TOP_REASONS_TITLE = "Withdrawal Decline Top Reasons";
export const WITHDRAWAL_APPROVED_TOP_REASONS_TITLE = "Withdrawal Approved Top Reasons";

export function formatWithdrawalTopReasonChartLabel(reasonCode) {
  if (reasonCode == null || String(reasonCode).trim() === "") return "—";
  const key = String(reasonCode).trim().toLowerCase();
  if (WITHDRAWAL_TOP_DECLINED_REASON_LABELS[key]) {
    return WITHDRAWAL_TOP_DECLINED_REASON_LABELS[key];
  }
  if (WITHDRAWAL_TOP_APPROVED_REASON_LABELS[key]) {
    return WITHDRAWAL_TOP_APPROVED_REASON_LABELS[key];
  }
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export const REASONS_BAR_COLORS = [
  { bg: "rgba(231, 76, 60, 0.88)", border: "#E74C3C" },
  { bg: "rgba(155, 89, 182, 0.88)", border: "#9B59B6" },
  { bg: "rgba(52, 152, 219, 0.88)", border: "#3498DB" },
  { bg: "rgba(26, 188, 156, 0.88)", border: "#1ABC9C" },
  { bg: "rgba(243, 156, 18, 0.88)", border: "#F39C12" },
  { bg: "rgba(230, 126, 34, 0.88)", border: "#E67E22" },
  { bg: "rgba(46, 204, 113, 0.88)", border: "#2ECC71" },
  { bg: "rgba(238, 114, 188, 0.88)", border: "#EE72BC" },
  { bg: "rgba(97, 119, 232, 0.88)", border: "#6177E8" },
];
